import React, { Component, useEffect, useState } from 'react';
import './index.css';

// or 'antd/dist/antd.less'

import {
  Form,
  Input,
  DatePicker,
  Select,
} from 'antd';
import InputPhone from "./input-phone";
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import locale from 'antd/es/date-picker/locale/ru_RU';
import { QueryDetail, QueryOrder, READWITH, errorCatch } from 'fennec-ui';
import { useTranslation } from 'react-i18next';
const { Option } = Select;

function String({ value, onChange }) {
  return (
    <Input allowClear value={value} onChange={(v) => {
      let val = v.target.value
      if (val) {
        val = val.replace(/\s/g, '');
      }
      onChange(val)
    }
    } style={{ width: "100%" }} />
  )
}

function StringEe({ value, onChange }) {
  return (
    <Input allowClear value={value} onChange={(v) => {
      let val = v.target.value
      if (val) {
        val = val.replace(/Ё/g, 'E').replace(/ё/g, 'e');
      }
      onChange(val)
    }
    } style={{ width: "100%" }} />
  )
}

export default function UserUpdate(props) {
  const { object, form, auth } = props;

  const { t } = useTranslation()

  React.useEffect(() => {
    form.resetFields();
    if (object) {
      form.setFieldsValue({
        ...object,
        birthday: (object && object.birthday) ? dayjs(object.birthday) : undefined,
      });
    }
  }, [object])

  const [city, setCity] = useState([]);
  useEffect(() => {
    READWITH(auth, "City", [
      QueryOrder("name", "ASC"),
      QueryDetail("model")
    ], ({ data }) => {
      if (data && data.length > 0) {
        setCity(data);
      }
    }, errorCatch);
  }, []);

  const cityOptions = city.map((i) => <Option key={i.ID} value={i.ID}>{i.name}</Option>);

  return (
    <Form
      form={form}
      onFinish={props.submit}
      labelAlign={"left"}
      layout={"vertical"}
      initialValues={{
        ...object,
        birthday: (object && object.birthday) ? dayjs(object.birthday) : undefined,
      }}
    >
      <Form.Item label={t("user.Фамилия")}
        name="lastname"
        rules={[{ required: true, message: t('user.Пожалуйста, введите фамилию!') }]}
      >
        <Input />
      </Form.Item>
      <Form.Item label={t("user.Имя")}
        name="firstname"
        rules={[{ required: true, message: t('user.Пожалуйста, введите имя!') }]}
      >
        <Input />
      </Form.Item>
      <Form.Item label={t("user.Отчество")}
        name="patronymic"
      >
        <Input />
      </Form.Item>
      <Form.Item label={t("user.Дата рождения")}
        name="birthday"
        rules={[{ required: true, message: t('user.Пожалуйста, введите дату рождения!') }]}
      >
        <DatePicker format="DD.MM.YYYY" locale={locale} />
      </Form.Item>
      <Form.Item label={t("user.Город")}
        name="cityID"
      >
        <Select
          allowClear
          showSearch
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {cityOptions}
        </Select>
      </Form.Item>
      <Form.Item label={t("user.Телефон")}
        name="phone"
        rules={[
          { required: true, message: t('user.Пожалуйста, введите телефон!') },
          { pattern: /\d{8,}/g, message: t('user.Пожалуйста, введите телефон!') }
        ]}
      >
        <InputPhone />
      </Form.Item>
      <Form.Item label={t("user.Псевдоним")}
        name="aliase"
      >
        <Input />
      </Form.Item>
    </Form>
  );
}

